import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto px-6 pt-6 pb-24" }
const _hoisted_2 = { class: "p-3 bg-[#2B2C32] border-0 rounded-lg" }
const _hoisted_3 = { class: "flex justify-between mb-3" }
const _hoisted_4 = { class: "flex items-center cursor-pointer" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "mb-6 max-w-[760px]" }
const _hoisted_7 = { class: "ml-2 mt-2" }
const _hoisted_8 = { class: "text-xs text-grey mt-2" }
const _hoisted_9 = {
  key: 0,
  class: "field-error text-sm mt-1 text-theme-red"
}
const _hoisted_10 = { class: "ml-2 max-w-[760px]" }
const _hoisted_11 = { class: "admin-table py-4" }
const _hoisted_12 = { class: "cursor-pointer text-sm" }
const _hoisted_13 = { class: "admin-table border-t-[2px] border-field-black py-4" }
const _hoisted_14 = { class: "cursor-pointer text-sm" }
const _hoisted_15 = { class: "ml-7 flex flex-col gap-5 relative" }
const _hoisted_16 = {
  key: 0,
  class: "absolute top-0 left-0 w-full bg-[#2b2c31] h-full opacity-40"
}
const _hoisted_17 = { class: "flex flex-col gap-1" }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { class: "flex flex-col gap-1" }
const _hoisted_20 = ["textContent"]
const _hoisted_21 = { class: "flex flex-col gap-1" }
const _hoisted_22 = ["onkeypress"]
const _hoisted_23 = ["textContent"]
const _hoisted_24 = { class: "flex flex-col gap-1" }
const _hoisted_25 = ["textContent"]
const _hoisted_26 = { class: "mt-10" }
const _hoisted_27 = { class: "admin-table mt-2" }
const _hoisted_28 = { class: "cursor-pointer text-sm" }
const _hoisted_29 = { class: "admin-table mt-2" }
const _hoisted_30 = { class: "cursor-pointer text-sm" }
const _hoisted_31 = {
  key: 1,
  class: "text-center text-theme-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.vg_selectedLocation.id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_4, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-[20px] mr-4 text-grey" }, "Pick Up", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.pickupActive) = $event)),
                          class: "hidden peer"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.pickupActive]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.pickupActive ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                        }, null, 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.pickupActive ? 'text-theme-green' : 'text-[#F53333]'])
                        }, _toDisplayString(_ctx.form.pickupActive ? 'On' : 'Off'), 3)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        disabled: _ctx.isInvalidToSave(),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save())),
                        class: "h-10 disabled:bg-theme-grey disabled:cursor-default disabled:text-theme-green hover:bg-theme-green border-0 hover:text-white rounded-[4px] cursor-pointer text-theme-green bg-white py-2 px-4 uppercase"
                      }, "Save", 8, _hoisted_5)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-sm" }, "Pickup Note:", -1)),
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.pickupNotice) = $event)),
                          rows: "4",
                          class: "block bg-gray-black w-full text-sm text-white rounded border-none p-3 resize-none",
                          placeholder: "Enter pickup note"
                        }, null, 512), [
                          [_vModelText, _ctx.form.pickupNotice]
                        ]),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.pickupNoticeLength) + "/256 characters ", 1),
                        (_ctx.pickupNoticeOverflow)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Character limit exceeded. Maximum 256 characters allowed. "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-sm" }, "Ordering Options:", -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: "1",
                            class: "mr-3",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.enableAsap) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.form.enableAsap]
                          ]),
                          _cache[17] || (_cache[17] = _createTextVNode("ASAP ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: "1",
                            class: "mr-3",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.pickupTimeSlots) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.form.pickupTimeSlots]
                          ]),
                          _cache[18] || (_cache[18] = _createTextVNode("Scheduled Ordering ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (_ctx.form.pickupTimeSlots == false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-sm" }, "Time Slots", -1)),
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-sm text-grey" }, "Select the length of the time slot the customer can choose.", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass('input-wrapper max-w-[260px] ' + (_ctx.form.timeSlotDuration.error_type))
                          }, [
                            _withDirectives(_createElementVNode("select", {
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validateFields(['timeSlotDuration']))),
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.timeSlotDuration.value) = $event)),
                              class: "border-none block rounded bg-gray-black w-full text-sm"
                            }, [...(_cache[19] || (_cache[19] = [
                              _createStaticVNode("<option value=\"\">-- Select --</option><option value=\"15\">15 minutes interval</option><option value=\"30\">30 minutes interval</option><option value=\"45\">45 minutes interval</option><option value=\"60\">60 minutes interval</option><option value=\"90\">90 minutes interval</option><option value=\"120\">120 minutes interval</option>", 7)
                            ]))], 544), [
                              [
                                _vModelSelect,
                                _ctx.form.timeSlotDuration.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            (_ctx.form.timeSlotDuration.error_message)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "field-error label-text mt-1",
                                  textContent: _toDisplayString(_ctx.form.timeSlotDuration.error_message)
                                }, null, 8, _hoisted_18))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-sm" }, "Order Prep Time", -1)),
                          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-sm text-grey" }, "How long does it take your staff to prepare orders for pickup. This setting is used to prevent orders when time slots are full until they have been prepared.", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass('input-wrapper max-w-[260px] ' + (_ctx.form.orderPrepTime.error_type))
                          }, [
                            _withDirectives(_createElementVNode("select", {
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateFields(['orderPrepTime']))),
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.orderPrepTime.value) = $event)),
                              class: "border-none block rounded bg-gray-black w-full text-sm"
                            }, [...(_cache[22] || (_cache[22] = [
                              _createStaticVNode("<option value=\"\">-- Select --</option><option value=\"15\">15 minutes interval</option><option value=\"30\">30 minutes interval</option><option value=\"45\">45 minutes interval</option><option value=\"60\">60 minutes interval</option><option value=\"90\">90 minutes interval</option><option value=\"120\">120 minutes interval</option>", 7)
                            ]))], 544), [
                              [
                                _vModelSelect,
                                _ctx.form.orderPrepTime.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            (_ctx.form.orderPrepTime.error_message)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "field-error label-text mt-1",
                                  textContent: _toDisplayString(_ctx.form.orderPrepTime.error_message)
                                }, null, 8, _hoisted_20))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-sm" }, "Orders Per Timeslot", -1)),
                          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-sm text-grey" }, "Max number of orders that can be placed in each timeslot to control the flow of your orders.", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass('input-wrapper ' + (_ctx.form.orderLimitPerTimeSlot.error_type))
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              onkeypress: _ctx.preventNonNumbers,
                              onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateFields(['orderLimitPerTimeSlot']))),
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.orderLimitPerTimeSlot.value) = $event)),
                              class: "max-w-[260px] placeholder-white block bg-gray-black w-full text-sm text-white rounded border-none",
                              type: "number"
                            }, null, 40, _hoisted_22), [
                              [
                                _vModelText,
                                _ctx.form.orderLimitPerTimeSlot.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            (_ctx.form.orderLimitPerTimeSlot.error_message)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "field-error label-text mt-1",
                                  textContent: _toDisplayString(_ctx.form.orderLimitPerTimeSlot.error_message)
                                }, null, 8, _hoisted_23))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-sm" }, "Advanced Ordering", -1)),
                          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-sm text-grey" }, "Only allow to set 3 days in advance.", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass('input-wrapper max-w-[260px] ' + (_ctx.form.timeSlotPeriod.error_type))
                          }, [
                            _withDirectives(_createElementVNode("select", {
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateFields(['timeSlotPeriod']))),
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.timeSlotPeriod.value) = $event)),
                              class: "border-none block rounded bg-gray-black w-full text-sm"
                            }, [...(_cache[27] || (_cache[27] = [
                              _createElementVNode("option", { value: "" }, "-- Select --", -1),
                              _createElementVNode("option", { value: "1" }, "1 day", -1),
                              _createElementVNode("option", { value: "2" }, "2 days", -1),
                              _createElementVNode("option", { value: "3" }, "3 days", -1)
                            ]))], 544), [
                              [
                                _vModelSelect,
                                _ctx.form.timeSlotPeriod.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            (_ctx.form.timeSlotPeriod.error_message)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: "field-error label-text mt-1",
                                  textContent: _toDisplayString(_ctx.form.timeSlotPeriod.error_message)
                                }, null, 8, _hoisted_25))
                              : _createCommentVNode("", true)
                          ], 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-sm" }, "Payment Methods Displayed to Customer", -1)),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("label", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              value: "1",
                              class: "mr-3",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.payAtStore) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.form.payAtStore]
                            ]),
                            _cache[30] || (_cache[30] = _createTextVNode("Pay at the store ", -1))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", _hoisted_30, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: "1",
                            class: "mr-3",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.payOnline) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.form.payOnline]
                          ]),
                          _cache[32] || (_cache[32] = _createTextVNode("Pay Online ", -1))
                        ])
                      ])
                    ])
                  ])
                ], 64))
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_31, "Please select a location from the top left corner."))
    ])
  ]))
}